export default __webpack_public_path__ + "static/media/riverTubing4.4dc9c979.webp";